import { AuthState, DEFAULT_UI_STATE, State } from "../types";

export interface ToggleActiveKeyAction {
  type: "TOGGLE ACTIVE KEY";
}
export const toggleActiveKey = (state: State, _: ToggleActiveKeyAction): State => {
  if (state.auth.state !== AuthState.loggedIn) {
    return state;
  }
  switch (state.auth.activeKey) {
    case "live":
      if (state.auth.user.api_keys.test === null) {
        return state;
      }
      return {
        ...DEFAULT_UI_STATE,
        auth: {
          activeKey: "test",
          authString: window.btoa(`${state.auth.user.api_keys.test}:`),
          state: AuthState.loggedIn,
          token: state.auth.user.api_keys.test,
          user: state.auth.user,
        },
      };
    case "test":
      if (state.auth.user.api_keys.live === null) {
        return state;
      }
      return {
        ...DEFAULT_UI_STATE,
        auth: {
          activeKey: "live",
          authString: window.btoa(`${state.auth.user.api_keys.live}:`),
          state: AuthState.loggedIn,
          token: state.auth.user.api_keys.live,
          user: state.auth.user,
        },
      };
  }
};
